// quote-card 编辑器：quote/author/background。
import { useTranslation } from 'react-i18next'
import type { EditorContext } from '../_shared/types'
import type { QuoteData, QuoteBg } from './types'
import { Field, TextArea, TextInput, SelectInput } from '../../components/editor-controls'

const QUOTE_BGS: QuoteBg[] = ['dark', 'warm', 'cool', 'minimal']

export function QuoteCardEditor({ data, update }: EditorContext) {
  const { t } = useTranslation()
  const d = data as unknown as QuoteData
  return (
    <>
      <Field label={t('editor.quote')}>
        <TextArea value={d.quote ?? ''} onChange={(v) => update((dd) => { dd.quote = v })} />
      </Field>
      <Field label={t('editor.author')}>
        <TextInput value={d.author ?? ''} onChange={(v) => update((dd) => { dd.author = v })} />
      </Field>
      <Field label={t('editor.background')}>
        <SelectInput<QuoteBg>
          value={(d.background ?? 'dark') as QuoteBg}
          options={QUOTE_BGS}
          onChange={(v) => update((dd) => { dd.background = v })}
        />
      </Field>
    </>
  )
}
